import { Component, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ISupplierSummary } from '../../../app/interfaces';
import { AngularFireDatabase } from 'angularfire2/database';
import { isNil, get } from 'lodash';

/**
 * Shows a list of suppliers, and emits an event once one is selected
 */
@Component({
  selector: 'suppliers-list',
  templateUrl: 'suppliers-list.html'
})
export class SuppliersListComponent {

  /** Will emit a value whenever an item is selected */
  @Output() itemSelected = new EventEmitter<string>();

  /** A stream with an array of all supplier summaries */
  public suppliers$: Observable<ISupplierSummary[]>;

  constructor(private db: AngularFireDatabase) {

    this.suppliers$ = this.db.list('suppliers')
      .filter( suppliers => !isNil(suppliers) )
      .map( ( suppliers: seafrozen.ISupplier[] ) => {
        /** Contains a summary of all suppliers */
        const supplierSummaries = suppliers.map(supplier => {

          const reports = supplier.reports || {};

          /** Contains a summary of a single suppliar */
          const supplierSummary: ISupplierSummary = {
            name: supplier.name,
            reportIds: Object.keys(reports),
            // $key is deprecated in v5.0
            //
            supplierId: get(supplier, '$key')
          };
          return supplierSummary;
        });

        return supplierSummaries;
      });
  }

  openSupplier( id: string ) {
    this.itemSelected.emit(id);
  }

}



// WEBPACK FOOTER //
// ./src/modules/supplier-selector/suppliers-list/suppliers-list.ts